import * as React from 'react'

function SvgTurnCoordinator(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='1em'
      height='1em'
      viewBox='0 0 537.942 539.909'
      {...props}
    >
      <defs>
        <filter
          x={-0.013}
          y={-0.212}
          width={1.026}
          height={1.423}
          colorInterpolationFilters='sRGB'
          id='turn_coordinator_svg__k'
        >
          <feGaussianBlur stdDeviation={1.359} />
        </filter>
        <filter
          x={-0.013}
          y={-0.212}
          width={1.026}
          height={1.423}
          colorInterpolationFilters='sRGB'
          id='turn_coordinator_svg__m'
        >
          <feGaussianBlur stdDeviation={1.359} />
        </filter>
        <filter
          x={-0.025}
          y={-0.46}
          width={1.051}
          height={1.921}
          colorInterpolationFilters='sRGB'
          id='turn_coordinator_svg__g'
        >
          <feGaussianBlur stdDeviation={2.54} />
        </filter>
        <filter
          x={-0.037}
          y={-1.101}
          width={1.074}
          height={3.203}
          colorInterpolationFilters='sRGB'
          id='turn_coordinator_svg__i'
        >
          <feGaussianBlur stdDeviation={0.421} />
        </filter>
        <filter
          x={-0.037}
          y={-2.289}
          width={1.073}
          height={5.579}
          colorInterpolationFilters='sRGB'
          id='turn_coordinator_svg__n'
        >
          <feGaussianBlur stdDeviation={0.373} />
        </filter>
        <filter colorInterpolationFilters='sRGB' id='turn_coordinator_svg__j'>
          <feGaussianBlur stdDeviation={12.324} />
        </filter>
        <filter
          x={-1.519}
          y={-0.166}
          width={4.038}
          height={1.333}
          colorInterpolationFilters='sRGB'
          id='turn_coordinator_svg__l'
        >
          <feGaussianBlur stdDeviation={2.427} />
        </filter>
        <filter
          x={-0.155}
          y={-0.096}
          width={1.31}
          height={1.191}
          colorInterpolationFilters='sRGB'
          id='turn_coordinator_svg__f'
        >
          <feGaussianBlur stdDeviation={2.672} />
        </filter>
        <linearGradient id='turn_coordinator_svg__d'>
          <stop offset={0} stopColor='#a8a8a8' />
          <stop offset={1} stopColor='#515151' />
        </linearGradient>
        <linearGradient id='turn_coordinator_svg__b'>
          <stop offset={0} stopColor='#1d1d1d' />
          <stop offset={1} stopColor='#acacac' />
        </linearGradient>
        <linearGradient id='turn_coordinator_svg__c'>
          <stop offset={0} stopColor='#222' />
          <stop offset={1} stopColor='#888' />
        </linearGradient>
        <linearGradient id='turn_coordinator_svg__a'>
          <stop offset={0} stopColor='#989898' />
          <stop offset={1} stopColor='#161616' />
        </linearGradient>
        <linearGradient
          x1={405.105}
          y1={100.92}
          x2={429.603}
          y2={491.396}
          id='turn_coordinator_svg__p'
          xlinkHref='#turn_coordinator_svg__b'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(1.03173 0 0 1.03173 -10.411 -40.92)'
        />
        <linearGradient
          x1={330.242}
          y1={125.127}
          x2={460.056}
          y2={575.402}
          id='turn_coordinator_svg__o'
          xlinkHref='#turn_coordinator_svg__c'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(1.00465 0 0 1.00465 1.296 -32.019)'
        />
        <linearGradient
          x1={346.578}
          y1={73.123}
          x2={545.035}
          y2={529.29}
          id='turn_coordinator_svg__e'
          xlinkHref='#turn_coordinator_svg__d'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(.9947 0 0 .9947 2.58 1.394)'
        />
        <radialGradient
          cx={436.262}
          cy={383.556}
          r={21.234}
          fx={436.262}
          fy={383.556}
          id='turn_coordinator_svg__h'
          xlinkHref='#turn_coordinator_svg__a'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(.99963 .03151 -.03166 1.34632 12.303 -151.543)'
        />
      </defs>
      <g transform='matrix(.8 0 0 .8 -78 33)'>
        <path
          d='M696.901 298.239c0 144.285-116.966 261.25-261.25 261.25-144.285 0-261.251-116.965-261.251-261.25S291.366 36.988 435.65 36.988c144.285 0 261.251 116.966 261.251 261.25zm-10.103 0c0 138.705-112.442 251.148-251.147 251.148-138.706 0-251.148-112.443-251.148-251.148 0-138.705 112.442-251.148 251.148-251.148 138.705 0 251.147 112.443 251.147 251.148z'
          fill='url(#turn_coordinator_svg__e)'
          fillRule='evenodd'
          stroke='#262626'
          strokeWidth={3}
        />
        <path
          d='M589.56 345.528c6.005 3.726-12.185 52.588-16.162 60.144l-137.753 32.101-131.524-28.06-15.275-62.042 300.715-2.143z'
          fill='#c1c2a9'
          fillRule='evenodd'
        />
        <path
          d='M462.5 391.786a20.714 33.516 0 11-41.429 0 20.714 33.516 0 1141.429 0z'
          transform='matrix(1.03448 0 0 .89344 -15.393 42.833)'
          fillOpacity={0.572}
          filter='url(#turn_coordinator_svg__f)'
        />
        <path
          d='M558.846 370.528c-47.338 11.332-95.599 14.36-144.51 11.54'
          opacity={0.7}
          fill='none'
          stroke='#fbf7d3'
          strokeWidth={12}
          strokeLinecap='round'
          filter='url(#turn_coordinator_svg__g)'
        />
        <path
          d='M462.5 391.786a20.714 33.516 0 11-41.429 0 20.714 33.516 0 1141.429 0z'
          transform='matrix(1.03448 0 0 .89344 -21.03 41.562)'
          fill='url(#turn_coordinator_svg__h)'
        />
        <path
          d='M422.496 368.305l.894.706c8.832.301 17.41.265 25.81-.01l.447-.389'
          fill='none'
          stroke='#000'
          strokeWidth={3}
          strokeOpacity={0.533}
          filter='url(#turn_coordinator_svg__i)'
        />
        <path
          d='M435.65 123.751c-96.364 0-174.469 78.137-174.469 174.5 0 96.364 78.105 174.47 174.469 174.47 96.363 0 174.469-78.106 174.469-174.47 0-96.363-78.106-174.5-174.47-174.5zM307.9 354.033c2.93-.04 6.743.866 10.844 1.78 38.735 8.646 91.064 11.907 116.906 11.907 25.842 0 78.17-3.26 116.906-11.906 9.374-2.092 17.161-4.122 16.688 5.062-.832 16.119 1.458 35.076-14.157 40.407-36.572 12.484-98.952 15.656-119.437 15.656-20.486 0-82.865-3.172-119.438-15.656-15.614-5.33-13.324-24.288-14.156-40.407-.266-5.166 2.076-6.792 5.844-6.843z'
          fill='#363636'
        />
        <path
          d='M678.822 328.73a246.477 246.477 0 11-492.954 0 246.477 246.477 0 11492.954 0z'
          transform='matrix(.6278 0 0 .6278 164.22 91.86)'
          fill='none'
          stroke='#000'
          strokeWidth={9.557}
          filter='url(#turn_coordinator_svg__j)'
        />
        <path
          d='M594.245 298.239c0 87.589-71.005 158.594-158.594 158.594-87.59 0-158.594-71.005-158.594-158.594 0-87.59 71.005-158.594 158.594-158.594s158.594 71.005 158.594 158.594zm70.71 0c0 126.641-102.663 229.304-229.304 229.304-126.642 0-229.305-102.663-229.305-229.304 0-126.642 102.663-229.305 229.305-229.305 126.641 0 229.304 102.663 229.304 229.305z'
          fill='#424242'
          fillRule='evenodd'
        />
        <text
          x={420.619}
          y={497.788}
          transform='scale(1.0381 .9633)'
          style={{
            textAlign: 'center',
            lineHeight: '100%'
          }}
          fontSize={15.592}
          fontWeight={400}
          fontStretch='semi-condensed'
          textAnchor='middle'
          fill='#fff'
          fontFamily='DejaVu Sans'
        >
          <tspan x={420.619} y={497.788}>
            {'NO PITCH'}
          </tspan>
          <tspan x={420.619} y={513.38}>
            {'INFORMATION'}
          </tspan>
        </text>
        <text
          x={469.345}
          y={99.672}
          transform='scale(.92836 1.07716)'
          style={{
            textAlign: 'center',
            lineHeight: '100%'
          }}
          fontSize={20.084}
          fontWeight={400}
          fontStretch='semi-condensed'
          textAnchor='middle'
          fill='#fff'
          fontFamily='DejaVu Sans'
        >
          <tspan x={469.345} y={99.672}>
            {'D.C.'}
          </tspan>
          <tspan x={469.345} y={119.756}>
            {'ELEC.'}
          </tspan>
        </text>
        <text
          x={426.44}
          y={362.399}
          transform='scale(1.02218 .9783)'
          style={{
            textAlign: 'center',
            lineHeight: '100%'
          }}
          fontSize={17.4}
          fontWeight={400}
          fontStretch='semi-condensed'
          textAnchor='middle'
          fill='#fff'
          fontFamily='DejaVu Sans'
        >
          <tspan x={426.44} y={362.399}>
            {'TURN COORDINATOR'}
          </tspan>
        </text>
        <rect
          width={29.787}
          height={14.517}
          rx={2.143}
          ry={2.143}
          x={248.208}
          y={311.118}
          fill='#fff'
          fillRule='evenodd'
        />
        <rect
          width={29.787}
          height={14.517}
          rx={2.143}
          ry={2.143}
          x={118.47}
          y={437.552}
          transform='rotate(-20.161)'
          fill='#fff'
          fillRule='evenodd'
        />
        <path
          d='M458.52 416.174c1.896-16.289 2.143-32.577 0-48.866m-45.74 48.866c-1.894-16.289-2.142-32.577 0-48.866'
          fill='none'
          stroke='#262626'
          strokeWidth={3}
        />
        <path
          d='M565.455 362.636c-83.842 18.482-167.685 19.056-251.528-1.515'
          fill='none'
          stroke='#fff'
          strokeWidth={2}
          filter='url(#turn_coordinator_svg__k)'
        />
        <text
          x={384.965}
          y={501.128}
          transform='scale(1.1327 .88285)'
          style={{
            textAlign: 'center',
            lineHeight: '100%'
          }}
          fontSize={23.179}
          fontWeight={400}
          fontStretch='semi-condensed'
          textAnchor='middle'
          fill='#fff'
          fontFamily='DejaVu Sans'
        >
          <tspan x={384.965} y={501.128}>
            {'2 MIN.'}
          </tspan>
        </text>
        <text
          x={575.616}
          y={425.353}
          style={{
            textAlign: 'center',
            lineHeight: '100%'
          }}
          fontSize={31.235}
          fontWeight={400}
          fontStretch='semi-condensed'
          textAnchor='middle'
          fill='#fff'
          fontFamily='DejaVu Sans'
        >
          <tspan x={575.616} y={425.353}>
            {'R'}
          </tspan>
        </text>
        <text
          x={295.468}
          y={425.353}
          style={{
            textAlign: 'center',
            lineHeight: '100%'
          }}
          fontSize={31.207}
          fontWeight={400}
          fontStretch='semi-condensed'
          textAnchor='middle'
          fill='#fff'
          fontFamily='DejaVu Sans'
        >
          <tspan x={295.468} y={425.353}>
            {'L'}
          </tspan>
        </text>
        <rect
          width={29.787}
          height={14.517}
          rx={2.143}
          ry={2.143}
          x={-622.449}
          y={311.118}
          transform='scale(-1 1)'
          fill='#fff'
          fillRule='evenodd'
        />
        <rect
          width={29.787}
          height={14.517}
          rx={2.143}
          ry={2.143}
          x={-698.838}
          y={137.465}
          transform='scale(-1 1) rotate(-20.161)'
          fill='#fff'
          fillRule='evenodd'
        />
        <path
          d='M324.178 362.166c-2.802 11.19-4.52 23.81-3.571 35'
          opacity={0.2}
          fill='none'
          stroke='#000'
          strokeWidth={5}
          strokeLinecap='round'
          filter='url(#turn_coordinator_svg__l)'
        />
        <path
          d='M565.455 367.434c-83.842 18.482-167.685 19.056-251.528-1.515'
          fill='none'
          stroke='#fff'
          strokeWidth={2}
          filter='url(#turn_coordinator_svg__m)'
        />
        <path
          d='M423.885 415.224c8.423.547 16.546.493 24.45.003'
          fill='none'
          stroke='#000'
          strokeWidth={3}
          strokeOpacity={0.533}
          filter='url(#turn_coordinator_svg__n)'
        />
        <path
          d='M678.822 328.73a246.477 246.477 0 11-492.954 0 246.477 246.477 0 11492.954 0z'
          transform='translate(37.888 -4.196) scale(.92001)'
          fill='none'
          stroke='#000'
          strokeWidth={6.522}
          filter='url(#turn_coordinator_svg__j)'
        />
        <path
          d='M683.273 298.239c0 136.758-110.864 247.623-247.622 247.623-136.759 0-247.623-110.865-247.623-247.623 0-136.759 110.864-247.623 247.623-247.623 136.758 0 247.622 110.864 247.622 247.623zm-20.86 0C662.412 423.476 560.887 525 435.65 525S208.889 423.476 208.889 298.24 310.414 71.477 435.651 71.477 662.412 173.002 662.412 298.24z'
          fill='url(#turn_coordinator_svg__o)'
          fillRule='evenodd'
          stroke='#363636'
        />
        <path
          d='M689.948 298.239c0 140.444-113.853 254.297-254.297 254.297-140.445 0-254.297-113.853-254.297-254.297 0-140.445 113.852-254.297 254.297-254.297 140.444 0 254.297 113.852 254.297 254.297zm-9.834 0c0 135.013-109.45 244.463-244.463 244.463-135.014 0-244.463-109.45-244.463-244.463 0-135.013 109.45-244.463 244.463-244.463 135.013 0 244.463 109.45 244.463 244.463z'
          fill='url(#turn_coordinator_svg__p)'
          fillRule='evenodd'
        />
      </g>
    </svg>
  )
}

export default SvgTurnCoordinator
